// extracted by mini-css-extract-plugin
export default {"wrapper":"Communities_wrapper__wXgpx","community":"Communities_community__oRd9y","title":"Communities_title__MkuFQ","cv":"Communities_cv__sYBKu"};